import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Instagram, Facebook, HeartHandshake  } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-white text-white pt-16 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-xl font-medium tracking-tight">Beautique Mariam</span>
            </div>
            <p className="text-black mb-4">
              Exklusive Behandlungen für dein Wohlbefinden – stilvoll, elegant und professionell.
            </p>
            <div className="flex space-x-4">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" 
                 className="text-white hover:text-gray-300 transition-colors">
                <Instagram size={20} />
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-4">Kontakt</h3>
            <div className="space-y-3 text-black">
              <div className="flex items-start space-x-3">
                <HeartHandshake size={18} className="flex-shrink-0 mt-1" />
                <span>Beautique Mariam</span>
              </div>
              <div className="flex items-start space-x-3">
                <Phone size={18} className="flex-shrink-0 mt-1" />
                <span>+49 17663182248</span>
              </div>
              <div className="flex items-start space-x-3">
                <MapPin size={18} className="flex-shrink-0 mt-1" />
                <span>Belgradstraße 154<br />80804 München</span>
              </div>
            </div>
          </div>
          
          <div>
            <h3 className="text-lg font-medium mb-4">Öffnungszeiten</h3>
            <div className="space-y-2 text-black">
              <div className="flex justify-between">
                <span>Montag - Samstag: nach Terminvereinbarung</span>
              </div>
              <div className="flex justify-between">
                <span>Sonntag: Geschlossen</span>
              </div>
            </div>
          </div>
        </div>
        
        <hr className="border-black mb-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center text-black text-sm">
          <div className="mb-4 md:mb-0">
            © {new Date().getFullYear()} Beautique Mariam. Alle Rechte vorbehalten.
          </div>
          <div className="flex space-x-4">
            <Link to="/imprint" className="hover:text-white transition-colors">
              Impressum
            </Link>
            <Link to="/privacy" className="hover:text-white transition-colors">
              Datenschutz
            </Link>
            <Link to="/cookies" className="hover:text-white transition-colors">
              Cookie-Richtlinie
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;